export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  searchText: string;
  sortField: string;
  sortOrder: string;
  status: number;
};

export type MasterTableDataType = {
  freqId: number;
  freqStatus: number;
  freqName: string;
  freqAmount: number | string | null;
  freqClinicId: number;
  freqCode: string;
};

export type MasterDataType = {
  clinicId: number;
  amount: number;
  code: string;
  id: number;
  name: string;
  status: number;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  amount: number | string|null;
  code: string;
  name: string;
  status: number;
};

export const initialFormData: MasterFormDataType = {
  amount: null,
  code: "",
  name: "",
  status: 1,
};
